// The cap must test the value, not its truthiness. `0` and `null`
// are the documented "auto" (no cap); a negative integer is truthy and smaller
// than every count, so a truthiness guard would skip every copy in the stack —
// including the base facing, deleting the product from the respondent shelf.
export function stackCopyHidden(maxStacking, count, verticalIndex) {
  return maxStacking > 0 && count - verticalIndex > maxStacking
}
